import { connect } from 'react-redux';
import { getAliasDataById, fetchUpdateAlias, fetchAddAlias } from "../../../../reducers/account/aliases";
import { 
    getCurrentContinent, 
    setCurrentContinent, 
    getCountriesData, 
    getContinentsData, 
    setCurrentContinentByCountry 
} from '../../../../reducers/common/location';
import AddAliasModal from "./AddAliasModal";
import { getActiveModal, hideModal, MODAL_ADD_ALIAS } from "../../../../reducers/common/activeModal";
import { resetSubmitFormData } from "../../../../reducers/common/submitForm";
import { getTranslation } from "../../../../reducers/common/localization";

const mapStateToProps = (state, { id }) => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_ADD_ALIAS,
        data: getAliasDataById(state, id),
        translation: getTranslation(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAdd: (data) => {
            dispatch(fetchAddAlias(data));
        },
        onEdit: (id, data) => {
            dispatch(fetchUpdateAlias(id, data));
        },
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        setCurrentContinentByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAliasModal);



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/addAliasModal/AddAliasModal.container.js